module.exports = __webpack_public_path__ + "static/media/RidesTwo.50dd9770.jpg";